import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const TotalValuesDesktop = styled.div`
  grid-template-columns: auto 130px 130px 190px;
  padding-top: 20px;
  font-weight: bold;

  ${mq({
    display: ['none', 'none', 'none', 'grid'],
  })}
`

export const TotalValuesMobile = styled.div`
  grid-template-columns: auto 130px 130px 190px;
  padding-top: 20px;
  font-weight: bold;

  ${mq({
    display: ['block', 'block', 'block', 'none'],
  })}

  .total {
    display: grid;
    grid-template-columns: 50% 50%;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`
